import { Base64 } from 'js-base64'
import type { FileRouteParams } from '@jotta/types/schemas/FileRouteSchema'
import { createPath, removeTrailingSlash } from '@jotta/utils/pathUtils'
import { isString } from 'remeda'
import { getFileRouteParams } from './getFileRouteParams'

export function routeParamsToApiPath(route: string | FileRouteParams) {
  const params = isString(route) ? getFileRouteParams(route) : route
  const { context } = params
  const routePath = removeTrailingSlash(createPath(params['*'] || ''))
  const contextPath = createPath(context)
  if (routePath === '/') {
    return contextPath
  }
  switch (context) {
    // On file search the file viewer paths are base64 encoded because there is no
    // traversable url path structure in this context
    case 'search': {
      const encodedPath = params['*']
      if (encodedPath) {
        try {
          const decoded = Base64.decode(encodedPath)
          if (!decoded.startsWith('/')) {
            throw new Error('Invalid path')
          }
          return decoded
        } catch (error) {
          // Returning `/search` below causes the search page to redirect when the
          // path is invalid.
          // console.warn('Failed to decode path', error)
        }
      }
      return '/search'
    }
    case 'trash':
    case 'shared':
      return routePath
    default:
      return createPath(context, routePath)
  }
}
